import MaintenanceIndexVue from "@/views/maintenance/MaintenanceIndex.vue";

const maintenance = [
    {
        path: '/maintenance',
        name: 'maintenance',
        component: MaintenanceIndexVue
    }
]

export default maintenance;